import React, { useState } from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';

import Cropper from 'ui/Cropper';
import Avatars from 'ui/Avatars';
import withStyles from './styles';

function readFileAsUrl(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.onerror = err => reject(err);
        reader.readAsDataURL(file);
    });
}

function validateImage(file) {
    if (file.type.substr(0, 6) === 'image/') {
        return file;
    }
    return null;
}

function Image({ classes, name, label, value, onChange, color }) {
    const [src, setSrc] = useState(value);
    const [newSrc, setNewSrc] = useState('');
    const [opened, setOpened] = useState(false);

    const onFileChange = async e => {
        const image = validateImage(e.target.files[0]);
        if (image) {
            setNewSrc(await readFileAsUrl(image));
            setOpened(true);
        } else {
            console.warn('Only images');
        }
        // Reset the input value to allow selecting the same file again
        e.target.value = '';
    };
    const onCrop = data => {
        setOpened(false);
        setSrc(URL.createObjectURL(data));
        setNewSrc('');
        onChange(data);
    };
    const onReset = () => {
        setOpened(false);
        setSrc('');
        onChange();
    };
    const onClose = () => {
        setOpened(false);
        setSrc(value);
        setNewSrc('');
    };
    return (
        <FormControl
            className={classes.imageContainer}
            margin="normal"
            variant="outlined"
        >
            <InputLabel shrink className={classes.imageLabel}>
                {label}
            </InputLabel>
            <Avatars.Normal src={src} alt={label} name={name} color={color} />
            <div className={classes.imageButtons}>
                <span className={classes.imageUploadButtonWrapper}>
                    <Button
                        className={classes.imageButton}
                        color="primary"
                        variant="contained"
                    >
                        Upload new image
                    </Button>
                    <input
                        className={classes.imageFileInput}
                        type="file"
                        onChange={onFileChange}
                    />
                </span>
                {src && (
                    <Button
                        onClick={onReset}
                        className={classes.imageButton}
                        color="primary"
                    >
                        Use default image
                    </Button>
                )}
            </div>
            <Cropper
                open={opened}
                src={newSrc}
                onClose={onClose}
                onCrop={onCrop}
            />
        </FormControl>
    );
}

export default withStyles(Image);
